import {
  COMMON_FORM_CONFIG_DEFAULTS,
  getDataSourceFormConfigs,
} from './DataSourceFormConfigs.constants';
import {
  IDataSourceTypesResponse,
  TDataSource,
} from 'Modules/Studio/DataSources/redux/initialState';

/**
 * Returns the default values for a data source based on its type and the selected data source type.
 * @param dataSourceType
 * @param selectedDatasourceDefaults
 * @returns the default data source config values as TDataSource
 */
export const getDataSourceDefaultValues = (
  dataSourceType: number,
  selectedDatasourceDefaults: IDataSourceTypesResponse
): TDataSource => {
  switch (dataSourceType) {
    // db
    case 1:
    case 2:
    case 3:
    case 4:
    case 12:
      return getDataSourceFormConfigs.DbForm(selectedDatasourceDefaults);

    // S3
    case 5:
    case 14:
      return getDataSourceFormConfigs.S3CsvForm(dataSourceType);

    // local CSV or Excel
    case 6:
    case 13:
      return getDataSourceFormConfigs.LocalFilesForm(dataSourceType);

    // API
    case 7:
      return getDataSourceFormConfigs.APIForm();

    // google big query
    case 8:
      return getDataSourceFormConfigs.GoogleBigQueryForm(selectedDatasourceDefaults);

    // Azure CSV or Excel
    case 9:
    case 15:
      return getDataSourceFormConfigs.AzureFilesForm(dataSourceType);

    // Kobai API
    case 10:
      return getDataSourceFormConfigs.KobaiAPIForm();

    // Databricks
    case 11:
      return getDataSourceFormConfigs.DataBricksForm(selectedDatasourceDefaults);

    default:
      console.warn(
        `No default values defined for dataSourceType: ${dataSourceType}. The form will not show`
      );
      return {
        ...COMMON_FORM_CONFIG_DEFAULTS,
        dataSourceType,
        connectionUrl: '',
        ingestionSchedule: [],
        props: {},
      };
  }
};
